import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { History } from 'src/app/models/server/history';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class FolderHistoriesService extends ServiceBase {
    /**
     * Constructeur
     * */
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Récupère les informations des documents d'un dossier
     * @param viewId : Id de la vue.
     * @param folderId: Id du dossier.
     */
    public list(viewId: number, folderId: string): Observable<History[]> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http
            .get<History[]>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/folders/${folderId}/histories`, httpOptions)
            .pipe(map((x) => History.fromArray(x)));
    }
}
